import type { LedgerAccount } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodLedgerAccountSchema } from './validations';

/**
 * Fetches a ledger account's currently effective version by the account's
 * own id, stable across all of its versions.
 *
 * @param ledgerAccountId - The ledger account's own id.
 * @param options - Additional request options.
 * @returns The ledger account data.
 * @throws VestigasHTTPError if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Ledger-Accounts/operation/get_ledger_account_ledger_accounts__ledger_account_id__get
 */
export const fetchLedgerAccount = async (
  ledgerAccountId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.LEDGER_ACCOUNT.GET(ledgerAccountId), {
      ...options,
      validate: {
        ...options?.validate,
        response: zodLedgerAccountSchema,
      },
    })
    .json<LedgerAccount>();
